// extracted by mini-css-extract-plugin
export var bodyFont = "index-module--body-font--dIjT2";
export var borderRadius = "index-module--border-radius--ldIIl";
export var clearButtonStyles = "index-module--clear-button-styles--lVEmr";
export var no_results_wrapper = "index-module--no_results_wrapper--1Zf7V";
export var progress = "index-module--progress--O698f";
export var results_list = "index-module--results_list--1VZ17";
export var results_list_wrapper = "index-module--results_list_wrapper--EQcuT";
export var titleFont = "index-module--title-font--ME2+o";